import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { createRoot } from 'react-dom/client'
import { CookiesProvider } from 'react-cookie';

const container = document.getElementById(`root`)
const root = createRoot(container)
root.render(
    <StrictMode>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
            <App /> 
        </CookiesProvider>
    </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
